import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../Unit.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../js/charSequenceJs.mjs';
import {
  Char__toInt_impl_vasixd3jl92hthlhyn7 as Char__toInt_impl_vasixd,
  _Char___init__impl__6a9atx1csff5kwtduxl as _Char___init__impl__6a9atx,
} from '../Char.mjs';
import {
  toByte4i43936u611k as toByte,
  numberToChar93r9buh19yek as numberToChar,
} from '../js/numberConversion.mjs';
import { copyOfwy6h3t5vzqpl as copyOf } from '../collections/_ArraysJs.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from './StringBuilderJs.mjs';
import { CharacterCodingException3mvgnmpleqbz9 as CharacterCodingException } from './CharacterCodingExceptionJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_REPLACEMENT_BYTE_SEQUENCE() {
  _init_properties_utf8Encoding_kt__9thjs4();
  return REPLACEMENT_BYTE_SEQUENCE;
}
var REPLACEMENT_BYTE_SEQUENCE;
function encodeUtf8(string, startIndex, endIndex, throwOnMalformed) {
  _init_properties_utf8Encoding_kt__9thjs4();
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(startIndex >= 0 && endIndex <= string.length && startIndex <= endIndex)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException().s2(toString(message));
  }
  var bytes = new Int8Array(imul(endIndex - startIndex | 0, 3));
  var byteIndex = 0;
  var charIndex = startIndex;
  while (charIndex < endIndex) {
    var _unary__edvuaz = charIndex;
    charIndex = _unary__edvuaz + 1 | 0;
    // Inline function 'kotlin.code' call
    var this_0 = charCodeAt(string, _unary__edvuaz);
    var code = Char__toInt_impl_vasixd(this_0);
    if (code < 128) {
      var _unary__edvuaz_0 = byteIndex;
      byteIndex = _unary__edvuaz_0 + 1 | 0;
      bytes[_unary__edvuaz_0] = toByte(code);
    } else if (code < 2048) {
      var _unary__edvuaz_1 = byteIndex;
      byteIndex = _unary__edvuaz_1 + 1 | 0;
      bytes[_unary__edvuaz_1] = toByte(code >> 6 | 192);
      var _unary__edvuaz_2 = byteIndex;
      byteIndex = _unary__edvuaz_2 + 1 | 0;
      bytes[_unary__edvuaz_2] = toByte(code & 63 | 128);
    } else if (code < 55296 || code >= 57344) {
      var _unary__edvuaz_3 = byteIndex;
      byteIndex = _unary__edvuaz_3 + 1 | 0;
      bytes[_unary__edvuaz_3] = toByte(code >> 12 | 224);
      var _unary__edvuaz_4 = byteIndex;
      byteIndex = _unary__edvuaz_4 + 1 | 0;
      bytes[_unary__edvuaz_4] = toByte(code >> 6 & 63 | 128);
      var _unary__edvuaz_5 = byteIndex;
      byteIndex = _unary__edvuaz_5 + 1 | 0;
      bytes[_unary__edvuaz_5] = toByte(code & 63 | 128);
    } else {
      var codePoint = codePointFromSurrogate(string, code, charIndex, endIndex, throwOnMalformed);
      if (codePoint <= 0) {
        var _unary__edvuaz_6 = byteIndex;
        byteIndex = _unary__edvuaz_6 + 1 | 0;
        bytes[_unary__edvuaz_6] = get_REPLACEMENT_BYTE_SEQUENCE()[0];
        var _unary__edvuaz_7 = byteIndex;
        byteIndex = _unary__edvuaz_7 + 1 | 0;
        bytes[_unary__edvuaz_7] = get_REPLACEMENT_BYTE_SEQUENCE()[1];
        var _unary__edvuaz_8 = byteIndex;
        byteIndex = _unary__edvuaz_8 + 1 | 0;
        bytes[_unary__edvuaz_8] = get_REPLACEMENT_BYTE_SEQUENCE()[2];
      } else {
        var _unary__edvuaz_9 = byteIndex;
        byteIndex = _unary__edvuaz_9 + 1 | 0;
        bytes[_unary__edvuaz_9] = toByte(codePoint >> 18 | 240);
        var _unary__edvuaz_10 = byteIndex;
        byteIndex = _unary__edvuaz_10 + 1 | 0;
        bytes[_unary__edvuaz_10] = toByte(codePoint >> 12 & 63 | 128);
        var _unary__edvuaz_11 = byteIndex;
        byteIndex = _unary__edvuaz_11 + 1 | 0;
        bytes[_unary__edvuaz_11] = toByte(codePoint >> 6 & 63 | 128);
        var _unary__edvuaz_12 = byteIndex;
        byteIndex = _unary__edvuaz_12 + 1 | 0;
        bytes[_unary__edvuaz_12] = toByte(codePoint & 63 | 128);
        charIndex = charIndex + 1 | 0;
      }
    }
  }
  return bytes.length === byteIndex ? bytes : copyOf(bytes, byteIndex);
}
function decodeUtf8(bytes, startIndex, endIndex, throwOnMalformed) {
  _init_properties_utf8Encoding_kt__9thjs4();
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(startIndex >= 0 && endIndex <= bytes.length && startIndex <= endIndex)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException().s2(toString(message));
  }
  var byteIndex = startIndex;
  var stringBuilder = StringBuilder().q1();
  while (byteIndex < endIndex) {
    var _unary__edvuaz = byteIndex;
    byteIndex = _unary__edvuaz + 1 | 0;
    var byte = bytes[_unary__edvuaz];
    if (byte >= 0)
      stringBuilder.t1(numberToChar(byte));
    else if (byte >> 5 === -2) {
      var code = codePointFrom2(bytes, byte, byteIndex, endIndex, throwOnMalformed);
      if (code <= 0) {
        stringBuilder.t1(_Char___init__impl__6a9atx(65533));
        byteIndex = byteIndex + (-code | 0) | 0;
      } else {
        stringBuilder.t1(numberToChar(code));
        byteIndex = byteIndex + 1 | 0;
      }
    } else if (byte >> 4 === -2) {
      var code_0 = codePointFrom3(bytes, byte, byteIndex, endIndex, throwOnMalformed);
      if (code_0 <= 0) {
        stringBuilder.t1(_Char___init__impl__6a9atx(65533));
        byteIndex = byteIndex + (-code_0 | 0) | 0;
      } else {
        stringBuilder.t1(numberToChar(code_0));
        byteIndex = byteIndex + 2 | 0;
      }
    } else if (byte >> 3 === -2) {
      var code_1 = codePointFrom4(bytes, byte, byteIndex, endIndex, throwOnMalformed);
      if (code_1 <= 0) {
        stringBuilder.t1(_Char___init__impl__6a9atx(65533));
        byteIndex = byteIndex + (-code_1 | 0) | 0;
      } else {
        var high = (code_1 - 65536 | 0) >> 10 | 55296;
        var low = code_1 & 1023 | 56320;
        stringBuilder.t1(numberToChar(high));
        stringBuilder.t1(numberToChar(low));
        byteIndex = byteIndex + 3 | 0;
      }
    } else {
      malformed(0, byteIndex, throwOnMalformed);
      stringBuilder.t1(_Char___init__impl__6a9atx(65533));
    }
  }
  return stringBuilder.toString();
}
function codePointFromSurrogate(string, high, index, endIndex, throwOnMalformed) {
  _init_properties_utf8Encoding_kt__9thjs4();
  if (!(55296 <= high ? high <= 56319 : false) || index >= endIndex) {
    return malformed(0, index, throwOnMalformed);
  }
  // Inline function 'kotlin.code' call
  var this_0 = charCodeAt(string, index);
  var low = Char__toInt_impl_vasixd(this_0);
  if (!(56320 <= low ? low <= 57343 : false)) {
    return malformed(0, index, throwOnMalformed);
  }
  return 65536 + ((high & 1023) << 10) | 0 | low & 1023;
}
function codePointFrom2(bytes, byte1, index, endIndex, throwOnMalformed) {
  _init_properties_utf8Encoding_kt__9thjs4();
  if ((byte1 & 30) === 0 || index >= endIndex) {
    return malformed(0, index, throwOnMalformed);
  }
  var byte2 = bytes[index];
  if (!((byte2 & 192) === 128)) {
    return malformed(0, index, throwOnMalformed);
  }
  return byte1 << 6 ^ byte2 ^ 3968;
}
function codePointFrom3(bytes, byte1, index, endIndex, throwOnMalformed) {
  _init_properties_utf8Encoding_kt__9thjs4();
  if (index >= endIndex) {
    return malformed(0, index, throwOnMalformed);
  }
  var byte2 = bytes[index];
  if ((byte1 & 15) === 0) {
    if (!((byte2 & 224) === 160)) {
      return malformed(0, index, throwOnMalformed);
    }
  } else if ((byte1 & 15) === 13) {
    if (!((byte2 & 224) === 128)) {
      return malformed(0, index, throwOnMalformed);
    }
  } else if (!((byte2 & 192) === 128)) {
    return malformed(0, index, throwOnMalformed);
  }
  if ((index + 1 | 0) === endIndex) {
    return malformed(1, index, throwOnMalformed);
  }
  var byte3 = bytes[index + 1 | 0];
  if (!((byte3 & 192) === 128)) {
    return malformed(1, index, throwOnMalformed);
  }
  return byte1 << 12 ^ byte2 << 6 ^ byte3 ^ -123008;
}
function codePointFrom4(bytes, byte1, index, endIndex, throwOnMalformed) {
  _init_properties_utf8Encoding_kt__9thjs4();
  if (index >= endIndex) {
    return malformed(0, index, throwOnMalformed);
  }
  var byte2 = bytes[index];
  if ((byte1 & 15) === 0) {
    if ((byte2 & 240) <= 128) {
      return malformed(0, index, throwOnMalformed);
    }
  } else if ((byte1 & 15) === 4) {
    if (!((byte2 & 240) === 128)) {
      return malformed(0, index, throwOnMalformed);
    }
  } else if ((byte1 & 15) > 4) {
    return malformed(0, index, throwOnMalformed);
  }
  if (!((byte2 & 192) === 128)) {
    return malformed(0, index, throwOnMalformed);
  }
  if ((index + 1 | 0) === endIndex) {
    return malformed(1, index, throwOnMalformed);
  }
  var byte3 = bytes[index + 1 | 0];
  if (!((byte3 & 192) === 128)) {
    return malformed(1, index, throwOnMalformed);
  }
  if ((index + 2 | 0) === endIndex) {
    return malformed(2, index, throwOnMalformed);
  }
  var byte4 = bytes[index + 2 | 0];
  if (!((byte4 & 192) === 128)) {
    return malformed(2, index, throwOnMalformed);
  }
  return byte1 << 18 ^ byte2 << 12 ^ byte3 << 6 ^ byte4 ^ 3678080;
}
function malformed(size, index, throwOnMalformed) {
  _init_properties_utf8Encoding_kt__9thjs4();
  if (throwOnMalformed)
    throw CharacterCodingException().sg('Malformed sequence starting at ' + (index - 1 | 0));
  return -size | 0;
}
var properties_initialized_utf8Encoding_kt_eee1vq;
function _init_properties_utf8Encoding_kt__9thjs4() {
  if (!properties_initialized_utf8Encoding_kt_eee1vq) {
    properties_initialized_utf8Encoding_kt_eee1vq = true;
    // Inline function 'kotlin.byteArrayOf' call
    REPLACEMENT_BYTE_SEQUENCE = new Int8Array([-17, -65, -67]);
  }
}
//region block: exports
export {
  decodeUtf8 as decodeUtf82vk39mtae8m3q,
  encodeUtf8 as encodeUtf82ot7wguqzn94o,
};
//endregion

//# sourceMappingURL=utf8Encoding.mjs.map
